{
  "version": 1,
  "asset_id": "84483515-aa97-4b76-a7ae-44d50ea76aea",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/84483515-aa97-4b76-a7ae-44d50ea76aea/home-hero-v2-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/84483515-aa97-4b76-a7ae-44d50ea76aea/home-hero-v2-1280.avif",
  "original_filename": "home-hero-v2-1280.avif",
  "size": 9649,
  "content_type": "image/avif",
  "created_at": "2026-10-10T12:40:01Z"
}
